import { Dispatcher } from 'flux';

export type AppAction = {
  type: string;
  // Allow payload properties; more specific types can be added over time.
  [key: string]: unknown;
};

const dispatcher = new Dispatcher<AppAction>();

export default dispatcher;
